<template>
    <!-- Facturador - Corte de caja -->
    <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <button type="button" class="btn btn-sm btn-outline-dark" v-shortkey="['esc']" @shortkey="cerrar"
                @click="cerrar">Cerrar</button>
        </div>
        <div class="contenedor_modal_completo_contenido">
            <b-container>
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h2>
                            Corte de caja
                        </h2>
                    </div>
                    <div class="col-sm-5 mt-3">
                        <label for="" class="form-label">Fecha Inicial</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
                    </div>
                    <div class="col-sm-5 mt-3">
                        <label for="" class="form-label">Fecha Final</label>
                        <input type="date" class="form-control form-control-sm" v-model="fecha_final">
                    </div>
                    <div class="col-sm-2 mt-5">
                        <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                            @click="obtener_resultados">Buscar</button>
                    </div>
                    <div class="col-sm-12 mt-3">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 14px;">
                            <thead>
                                <tr>
                                    <th style="width: 50%;">
                                        Origen
                                    </th>
                                    <th style="width: 50%;text-align: center;">
                                        Valores
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        Número de facturas de pago con efectivo
                                    </td>
                                    <td style="text-align: center;">
                                        {{ resultados.registros_efectivo }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Número de facturas de pago con tarjeta
                                    </td>
                                    <td style="text-align: center;">
                                        {{ resultados.registros_tarjeta }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Número de facturas con pago en efectivo y tarjeta
                                    </td>
                                    <td style="text-align: center;">
                                        {{ resultados.registros_ambos }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Número de facturas con pago por transferencia
                                    </td>
                                    <td style="text-align: center;">
                                        {{ resultados.registros_transferencia }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Total facturas
                                    </td>
                                    <td style="text-align: center;">
                                        {{ resultados.total_facturas }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Total Efectivo
                                    </td>
                                    <td style="text-align: center;">
                                        Q{{ total_efectivo.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Total Tarjeta
                                    </td>
                                    <td style="text-align: center;">
                                        Q{{ total_tarjeta.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Total Transferencia
                                    </td>
                                    <td style="text-align: center;">
                                        Q{{ total_transferencia.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                </tr>
                                <tr style="background-color: black;">
                                    <td style="text-align: right;color: white;font-size: 18px;padding-right: 10px;">
                                        Total a depositar
                                    </td>
                                    <td style="color: white;text-align: center;font-size: 18px;">
                                        Q{{ total_deposito.toLocaleString(undefined, {
                                            minimumFractionDigits: 2, maximumFractionDigits: 2
                                        }) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'CorteCaja',
        computed: {
            ...mapState(['datos_usuario', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                resultados: {},
                total_efectivo: 0,
                total_tarjeta: 0,
                total_transferencia: 0,
                total_deposito: 0
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_resultados() {
                let f = {
                    api: `movimientos-cabeceras/r/reporte-corte-caja-por-vendedor?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&empresa=${this.id_empresa_seleccionada}&sucursal=${this.datos_usuario.sucursal_asignada}&vendedor=${this.datos_usuario.id}`
                }

                let r = await this.obtener_data(f)
                this.resultados = r
                this.total_efectivo = r.total_efectivo
                this.total_tarjeta = r.total_tarjeta
                this.total_transferencia = r.total_transferencia
                this.total_deposito = r.total_efectivo
            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style></style>
